import React from "react";
import { Table, Button, ButtonGroup } from "reactstrap";
import NumberCommas from "../../../Components/NumberCommas/NumberCommas";

const PurchaseTable = ({
  purchaseItems,
  handleTableDetailIncrease,
  handleEdit,
  handleDelete,
}) => {
  console.log("🚀 ~ purchaseItems:", purchaseItems)
  const calculateTotals = () => {
    if (!purchaseItems || !purchaseItems.length) {
      return { totalQuantity: 0, totalPurchaseRate: 0, totalAmount: 0 };
    }

    return purchaseItems.reduce(
      (acc, item) => {
        return {
          totalQuantity: acc.totalQuantity + Number(item.quantity),
          totalPurchaseRate: acc.totalPurchaseRate + Number(item.purchaseRate),
          totalAmount:
            acc.totalAmount + Number(item.quantity) * Number(item.purchaseRate),
        };
      },
      { totalQuantity: 0, totalPurchaseRate: 0, totalAmount: 0 }
    );
  };

  return (
    <Table bordered>
      <thead>
        <tr>
          <th style={{ width: "60px" }}>S.N</th>
          <th>Product</th>
          <th>Mfg. Date</th>
          <th>Exp.Date</th>
          <th>Batch No.</th>
          <th style={{ width: "150px" }}>Quantity</th>
          <th style={{ width: "150px" }}>Purchase Rate</th>
          <th style={{ width: "150px" }}>Total</th>
          <th>
            <Button
              size="lg"
              className="btn btn-soft-success text-end"
              style={{
                padding: "7px",
                display: "flex",
                marginBottom: "5px",
              }}
              onClick={handleTableDetailIncrease}
            >
              +
            </Button>
          </th>
        </tr>
      </thead>
      <tbody>
        {purchaseItems && Array.isArray(purchaseItems) ? (
          purchaseItems.map((purchaseRecord, index) => (
            <tr key={purchaseRecord.key}>
              <td>{index + 1}</td>
              <td>{purchaseRecord.title || "N/A"}</td>
              <td>{purchaseRecord.mfgDate || "N/A"}</td>
              <td>{purchaseRecord.expDate || "N/A"}</td>
              <td>{purchaseRecord.batchNo || "N/A"}</td>
              <td className="text-end">{purchaseRecord.quantity}</td>
              <td className="text-end">
                {purchaseRecord.purchaseRate ? (
                  <NumberCommas number={parseFloat(purchaseRecord.purchaseRate)} />
                ) : (
                  "0"
                )}
              </td>
              <td className="text-end">
                <NumberCommas
                  number={purchaseRecord.quantity * purchaseRecord.purchaseRate}
                />
              </td>
              <td>
                <ButtonGroup>
                  <Button
                    size="sm"
                    color="btn btn-soft-warning"
                    className="btn btn-soft-primary"
                    style={{ marginRight: "5px" }}
                    onClick={() => handleEdit(index)}
                  >
                    <i className="ri-edit-line"></i>
                  </Button>
                  <Button
                    size="sm"
                    className="btn btn-soft-danger"
                    onClick={() => handleDelete(index)}
                  >
                    <i className="ri-delete-bin-5-fill"></i>
                  </Button>
                </ButtonGroup>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="5">No Purchase details</td>
          </tr>
        )}
      </tbody>
      <tfoot>
        <tr className="table-light">
          <td colSpan="5" className="text-end fw-bold">
            Total:
          </td>
          <td className="text-end fw-bold">
            {calculateTotals().totalQuantity}
          </td>
          <td className="text-end fw-bold">
            <NumberCommas number={calculateTotals().totalPurchaseRate} />
          </td>
          <td className="text-end fw-bold">
            <NumberCommas number={calculateTotals().totalAmount} />
          </td>
          <td></td>
        </tr>
      </tfoot>
    </Table>
  );
};

export default PurchaseTable;
